import SingleDataBox from './SingleDataBox';

export type { SingleDataBoxProps } from './SingleDataBox';

export default SingleDataBox;
